// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"394b71f6","404":"896b8d86"}[chunkId] + ".chunk.js";
};